export default __webpack_public_path__ + "static/media/Hauora-ExtraLight.75dc0ba1.woff2";